import { Injectable } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';

@Injectable({ providedIn: 'root' })
export class PostplaceService {
    constructor(private upgrade: UpgradeModule) {}
    private get selection(): PostplaceSelectionClient {
        // Legacy customer and labour editors consume this same selection and search cache.
        return this.upgrade.$injector.get('selectCityService');
    }
    public initialize(webpage: string, parm: string): string {
        this.selection.selectedPostplace.id = '';
        this.selection.selectedPostplace.name = '';
        const current = this.selection.current[webpage] ??= { items: {} };
        return (current.items[parm] ??= { name: '' }).name;
    }
    public rememberSearch(webpage: string, parm: string, name: string): void {
        this.selection.current[webpage].items[parm].name = name;
    }
    public select(item: PostplaceSelectionItem): void {
        this.selection.selectedPostplace.id = item.item_id;
        this.selection.selectedPostplace.name = item.item_name;
    }
}
export interface PostplaceSelectionItem {
    item_id: string;
    item_name: string;
}
interface PostplaceSelectionClient {
    current: Record<string, { items: Record<string, { name: string }> }>;
    selectedPostplace: { id: string; name: string };
}
